import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import { ModalDirective } from 'ngx-bootstrap/modal/modal.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AuthenticationService } from './_services/index'

@Component({
    templateUrl: 'error.component.html',
})

export class ErrorComponent implements OnInit {
    constructor(private authenticationService: AuthenticationService, private router: Router) {
       
    }
    
    ngOnInit() {
        // CHECK THE isLoggedIn STATE HERE 
        if (!this.authenticationService.isLoggedIn()) {
            setTimeout(()=>{    
                this.router.navigateByUrl('/');
            },1);
        }
    }
}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/error.component.ts